import { createAction as typeSafeCreateAction } from 'typesafe-actions';
import Game from 'Game';

export const createAction = ((type, createHandler?) => {
    const createHandlerWrapper = (resolve: any) => {
        const resolveWrapper = (...args: any) => {
            const action = resolve(...args);
            Game.store.dispatch(action);

            return action;
        };

        return createHandler ? createHandler(resolveWrapper) : resolveWrapper;
    };

    return typeSafeCreateAction(type, createHandlerWrapper);
}) as typeof typeSafeCreateAction;
